import { RegularButton, CommonInput } from 'pg-ui-library';

import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const Content = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 2fr 1fr;
  grid-gap: 20px;
  margin-top: 20px;
`;

export const BeneficiariesTools = styled.h3`
  text-align: center;
`;

export const SubmitButton = styled(RegularButton)`
  margin: 0;
  min-width: 288px;
`;

export const PercentToPayInput = styled(CommonInput)`
  background: #fff;
  border: 1px solid #dbdbdc;
`;
